<template>
  <b-modal class="modal-xl" size="xl" style="max-width: 1140px;" id="paymentModal" ref="payment-modal" :title="title" :header-bg-variant="'secondary'" hide-footer hide-backdrop okVariant="secondary"  @show="getCart(); showCheckoutButton()" @hide="resetModal('main');clearModal();">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'credit-card']" size="1x" class="mr-2"/> {{ title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
    <template v-if="isLoading">
      <div class="vld-parent spinner-row text-center">
        <loading :active.sync="isLoading"
        :can-cancel="false"
        :color="'#047bf8'"
        :loader="'dots'"
        :is-full-page="false"></loading>
      </div>
    </template>
		<template v-else-if="!documents.length > 0 && !isLoading">
			<h5 class="text-danger">{{t('onlinePaymentModalNoDocsSelected','onlinePaymentModalNoDocsSelected')}}</h5>
			<p class="text-danger">{{t('onlinePaymentModalPleaseSelectDocsFirst','onlinePaymentModalPleaseSelectDocsFirst')}}</p>
		</template>
		<template v-else slot-scope="{ close }">
			<div class="container">
				<div v-if="attempted">
          <h4 :class="{'text-success': success, 'text-danger': !success}">{{ paymentResult }}</h4>
        </div>
				<div v-else-if="timedOut" class="alert"><p>{{ t('paymentSessionTimeoutMessage', 'paymentSessionTimeoutMessage') }}</p></div>
				<div class="row" v-else>
          <!--<div class="col-6 table-responsive" v-if="paidList.length > 0 || exceptionList.length > 0">
            <h3>These are the documents you can not pay for: </h3>
            <table class="table b-table table-striped table-hover table-bordered">
              <thead class="brand-color">
                <tr>
                  <th>Document Reference</th>
                  <th>Customer Reference</th>
                  <th>Total Value</th>
                  <th>Payment Status / Reason</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="document in paidList" :key="document.id">
                  <td><a target="_blank" :href="view + document.id">{{document.reference}}</a></td>
                  <td>{{ document.customer_reference }}</td>
                  <td>{{ currencySymbol }}{{ document.total_value }}</td>
                  <td>{{ document.payment_status }}</td>
                </tr>
                <tr v-for="document in exceptionList" :key="document.id">
                  <td><a target="_blank" :href="view + document.id">{{document.reference}}</a></td>
                  <td>{{ document.customer_reference }}</td>
                  <td>{{ currencySymbol }}{{ document.total_value }}</td>
                  <td>{{ document.payment_status }}</td>
                </tr>
              </tbody>
            </table>
            <ol class='text-info'>
              <li v-if="paidList.length > 0">
                <span><b>You can not pay for these again: </b></span>
                <span v-for="document in paid" :key="document.id">
                  <a target="_blank" :href="view + document.id">{{document.reference}}</a>&nbsp;
                </span>
                <br/>
                <sub class='mb-3'>Note: You can not pay for these again and have been removed from your list of items to be payed</sub>
              </li>
              <li v-if="exceptionList.length > 0">
                <span>You are not allowed to pay for these document types: </span>
                <span v-for="exception in exceptionList" :key="exception.id">
                  <a target="_blank" :href="view + exception.id">{{ exception.reference }} {{ exception.user_doc_type_name }}</a>&nbsp;
                </span>
              </li>
            </ol>
          </div>-->

					<div class="col-6">
            <h4><fontAwesomeIcon :icon="['fa', 'cart-arrow-down']" size="1x" class="mx-1"/>{{ t('yourCartText', 'yourCartText') }}</h4>
            <table class="table b-table table-striped table-hover table-bordered">
              <thead class="">
                <tr class="brand-color">
                  <th>{{ t('documentReference', 'documentReference') }}</th>
                  <th>{{ t('customerReference', 'customerReference') }}</th>
                  <th>{{ t('totalValueLabel', 'totalValueLabel') }}</th>
                  <th>{{ t('removeText', 'removeText') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="document in unpaidList" :key="document.id">
                  <td><a target="_blank" :href="view + document.id">{{document.reference}}</a></td>
                  <td>{{ document.customer_reference }}</td>
                  <td>{{ currencySymbol }}{{ document.total_value }}</td>
                  <td class="text-center">
                    <a href="javascript:;" @click="removeFromCart(document.id)">
                      <fontAwesomeIcon :icon="['fa', 'minus-circle']" size="1x" style="color: red"/>
                    </a>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="text-right" colspan="2">
                    Total
                  </td>
                  <td>
                    {{ currencySymbol }}{{ totalValue }}
                  </td>
                  <td>  &nbsp; </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="col-6">
            <template v-if="clientShortName.length > 4">
              <div class='text-danger' v-if="warning_for.includes(clientShortName)">
                {{ t('productionAccountInUserWarning', 'productionAccountInUserWarning') }}
              </div>
              <div v-else>
                <table class="table b-table table-striped table-hover table-bordered">
                  <thead class="bg-warning text-black">
                    <tr>
                      <th class="text-center" colspan="4">
                        {{ t('testCredentialsLabel', 'testCredentialsLabel') }}
                      </th>
                    </tr>
                    <tr>
                      <th>{{ t('cardNumberLabel', 'cardNumberLabel') }}</th>
                      <th>{{ t('cardDateLabel', 'cardDateLabel') }}</th>
                      <th>{{ t('CVNLabel', 'CVNLabel') }}</th>
                      <th>{{ t('cardHolderText', 'cardHolderText') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>4012001037461114 ( Accepted )</td>
                      <td>10/20</td>
                      <td>000</td>
                      <td>000</td>
                    </tr>
                    <tr>
                      <td>4000120000001154 ( Declined )</td>
                      <td>10/20</td>
                      <td>000</td>
                      <td>000</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
            <h4 class="px-2"><b>{{ t('aboutToMakePaymentToClientText', 'aboutToMakePaymentToClientText') }} <i>{{allTemplateDetails.name}}</i></b></h4>
            <table class="table b-table table-striped table-hover table-bordered">
              <tbody>
                <tr>
                  <th><h4>{{ t('totalValueLabel', 'totalValueLabel') }}</h4></th>
                  <th><h4>{{currencySymbol}}{{totalValue}}</h4></th>
                </tr>
              </tbody>
            </table>
            <div class="col-12 px-0 mb-2" v-if="ceilingError || floorError">
              <h5 class="text-danger" v-if="ceilingError">{{ t('providedAmountTooHighWarning', 'providedAmountTooHighWarning') }}</h5>
              <h5 class="text-danger" v-if="floorError">{{ t('providedAmountTooLowWarning', 'providedAmountTooLowWarning') }}</h5>
            </div>
            <div class="col-12 px-0 mb-2" v-if="allowCustomPayment">
              <b-input-group prepend="Custom amount" class="mt-3">
                <b-form-input v-model="random_amount" @keyup="getPayment()" :disabled="!showButton"></b-form-input>
              </b-input-group>
            </div>
            <div class="col-12 px-0">
              <hr class="mb-1 mt-1">
              <h5 class="text-danger" v-if="!showButton">{{ t('dontRefreshWhilePaymentProcessingWarning', 'dontRefreshWhilePaymentProcessingWarning') }}</h5>
              <h5 class="text-danger" v-if="incorrectValue">{{ t('paymentValueNotAllowed', 'paymentValueNotAllowed') }}</h5>
              <h5 class="text-danger" v-if="showCustomerCountError && customerCount">{{ t('customerCountPaymentError', 'customerCountPaymentError') }}: {{ customerCount }}</h5>
              <iframe v-if="!incorrectValue && !(showCustomerCountError && customerCount)" id="targetIframe" style="display: none; margin: auto;" :height="height" :width="width" scrolling= "no" frameBorder="0"></iframe>
            </div>
            <div class="col-12 px-0 text-right mt-2">
              <button aria-label="Cancel" data-dismiss="modal" class="btn btn-lg btn-secondary mr-2" type="button" @click="closeModal()">
                {{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
              </button>
              <button id="submit2" name="submit2" class="btn btn-lg btn-warning" v-if="showButton" :hidden="!showCheckout" :disabled="(ceilingError || floorError || incorrectValue || showCustomerCountError)" @click="getPayment();toggleCheckout();">{{ t('checkoutText', 'checkoutText') }}</button>
            </div>
          </div>

					<!--<template v-else>
						<p><b>We can not proceed to payment for the following reasons: </b></p>
						<ol class='text-danger'>
							<template v-if='has_not_sme'>
								<li>
									<span><b>Only SME customers can make payments online as this time.</b></span>
								</li>
							</template>
							<template v-else>
								<li v-if="has_multiple_types">
									<span><b>You have selected {{type_count}} different types of document for payment. Only one type of document can be payed for online at a time</b></span>
									<br/>
									<sub class='mb-3'>Note: Please return to the documents screen and confirm you have selected only one type of document for payment</sub>
								</li>
								<li v-else-if="has_multiple_customers">
									<span><b>You have selected documents from {{customer_count}} different accounts for payment. Documents from only one account can be payed for online at a time</b></span>
									<br/>
									<sub class='mb-3'>Note: Please return to the documents screen and confirm you have selected documents from only one account for payment</sub>
								</li>
								<li v-else-if="has_out_of_range">
									<span><b>The total value of this payment, £{{amount_paid}}, is outside the range (£{{min_range}} to £{{max_range}}) allowed to be payed online</b></span>
									<br/>
									<sub class='mb-3'>Note: The total value is what is left once exclusions have been removed from your selected list of items to be payed</sub>
								</li>
								<li v-else>
									<span><b>CANT PAY >:(</b></span>
								</li>
							</template>
						</ol>
					</template>-->
				</div>
			</div>
		</template>
    </template>
  </b-modal>
</template>

<script>
import { clientShortName } from '@/helpers/clientShortName.js'
import { mapGetters } from 'vuex'
import { RealexHpp } from '@/plugins/rxp-js2.js'
import Loading from 'vue-loading-overlay'

// NS-9511 DL - new functionality for online payments
export default {
	name: 'ModalPayment',
	inject: [
		'resetModal'
	],
	data() {
		return {
			title: 'Payment',
			buttonIsBusy: false,
			view: window.location.origin + '/document/view/online/',
			random_amount: 0,
			message_none: 'Getting details...',
			warning_for: ['tota','totatest'],
			height: '280px',
			width: '500px',
			paymentResult: null,
      showButton: true,
      showCheckout: true,
			attempted: false,
			success: false,
			hppResponse: {},
			timeout: null,
			timedOut: false,

			documents: [],
			paid: [],
			unpaid: [],
      exceptionList: [],
      forbiddenDocTypes: null,
			paidList: [],
			unpaidList: [],
      totalValue: 0,
      currencySymbol: '£',
      clientShortName: '',
      isHiding: false,
      allowCustomPayment: false,
      floorCustomAmount: 0,
      ceilingCustomAmount: 10000,
      ceilingError: false,
      customerCount: 0,
      floorError: false,
      incorrectValue: false,
      showCustomerCountError: false,
      isLoading: true
		}
  },
  components: {
    Loading
  },
	computed: {
    ...mapGetters(['allTemplateDetails']),
		paymentModal: {
			get: function() {
				return this.$attrs.modal
			},
			set: function(d) {
				this.paymentModal = d
			}
		},
		cart() {
		  return this.$store.getters['onlinePaymentStore/getCart'] || []
		},
		payment() {
		  return this.$store.getters['onlinePaymentStore/getPayment'] || []
		},
		hpp: function() {
			return this.payment.hpp || ''
		},
		paymentDetails: function() {
			return this.payment.details || {}
		},
		initialise: function() {
			return Object.keys(this.details).length > 0 && this.has_unpaid
    },
    customAmount: function() {
      return this.random_amount
    }
	},
	watch: {
    customAmount(newAmount) {
      if(this.ceilingCustomAmount && this.ceilingCustomAmount < newAmount) {
        this.ceilingError = true
      } else {
        this.ceilingError = false
      }

      if(this.floorCustomAmount && this.floorCustomAmount > newAmount) {
        this.floorError = true
      } else {
        this.floorError = false
      }

      this.incorrectValue = false
      this.showButton = true
    }
	},
	methods: {
    checkLimitValues() {
      if(this.totalValue && this.ceilingCustomAmount && this.totalValue > this.ceilingCustomAmount) {
        this.ceilingError = true
      } else {
        this.ceilingError = false
      }

      if(this.totalValue && this.floorCustomAmount && this.totalValue < this.floorCustomAmount) {
        this.floorError = true
      } else {
        this.floorError = false
      }
    },
    checkUsedCustomerCount() {
      if(this.customerCount > 1) {
        this.showCustomerCountError = true
      } else {
        this.showCustomerCountError = false
      }
    },
    showCheckoutButton() {
      this.showCheckout = true
    },
    toggleCheckout() {
      this.showCheckout = false
    },
		highlightDocuments() {
      if(this.paidList) {
        let paid = this.paidList
        paid.forEach( function(el) {
          document.getElementById('documents-table-client-specific__row_' + el.id ).classList.add('bg-danger')
          document.getElementById('documents-table-client-specific__row_' + el.id ).classList.add('text-white')
        })
      }
      if(this.exceptionList) {
        let exceptions = this.exceptionList
        exceptions.forEach( function(el) {
          document.getElementById('documents-table-client-specific__row_' + el.id ).classList.add('bg-danger')
          document.getElementById('documents-table-client-specific__row_' + el.id ).classList.add('text-white')
        })
      }

      this.$parent.alertMessage(this.paidList, this.exceptionList, this.forbiddenDocTypes)
      this.$refs['payment-modal'].hide()
      this.clearModal()
      this.resetModal('main')
    },
    closeModal() {
      this.$refs['payment-modal'].hide()
      this.clearModal()
      this.resetModal('main')
    },
		clearModal() {
      this.isHiding = true
			clearTimeout(this.timeout);
			this.$forceUpdate();  // Notice we have to use a $ here
			this.docIds = []
			this.newPostHouse = ''
			Object.assign(this.$data, this.$options.data())
    },
    getCart() {
      if(this.$attrs.modal.docuData) {
        if(!this.$attrs.modal.docuData.docsChecked) {
          this.$attrs.modal.docuData.docsChecked = []
        }
      }

			this.$store.dispatch('onlinePaymentStore/getCart',
			{
				documents: this.$attrs.modal.docuData.docsChecked
			}).then(response => {
				this.documents = response.all
				this.paid = response.paid
				this.unpaid = response.unpaid
        this.exceptionList = response.exceptionList
        this.forbiddenDocTypes = response.forbiddenDocTypes
				this.paidList = response.paidList
				this.unpaidList = response.unpaidList
        this.totalValue = response.totalValue
        this.currencySymbol = response.currencySymbol
        this.clientShortName = response.short_name
        this.allowCustomPayment = response.allow_random
        this.isLoading = false

        if(response.customer_count) {
          this.customerCount = response.customer_count
        }

        if(response.floor_amount) {
          this.floorCustomAmount = response.floor_amount
        }

        if(response.ceiling_amount) {
          this.ceilingCustomAmount = response.ceiling_amount
        }

        if(response.paidList.length > 0 || response.exceptionList.length > 0 || response.forbiddenDocTypes.length > 0) {
          this.highlightDocuments()
        } else {
          if(clientShortName() == 'tota' || clientShortName() == 'totatest') {
            this.checkLimitValues()
            this.checkUsedCustomerCount()
          }
          this.getPayment()
        }
			})
		},
    getPayment() {
      if(this.unpaid) {
        let self = this

        if(this.allowCustomPayment) {
          var paidAmount = this.random_amount
        } else {
          var paidAmount = this.totalValue
        }

        if(!paidAmount || paidAmount <= 0) {
          paidAmount = this.totalValue
        }

        this.$store.dispatch('onlinePaymentStore/getPayment',
        {
          documents: this.unpaid,
          amount_paid: paidAmount
        }).then(response => {
          if(response.details.AMOUNT && response.details.AMOUNT < 2) {
            this.incorrectValue = true
          }

          RealexHpp.setHppUrl(response.hpp)

          RealexHpp.embedded.init("submit2", "targetIframe",
            (answer, close) => {
              this.attempted = true
              close();
              clearTimeout(this.timeout);

              if(Object.keys(this.hppResponse).length > 0) {
                if( JSON.stringify(this.hppResponse) === JSON.stringify(answer) ) {
                  return false
                }
              }

              //console.log('answer')
              //console.log(answer)

              this.hppResponse = answer;
              this.getReceipt()

              if(answer.RESULT == '00'){
                this.success = true
                this.paymentResult = 'Payment successful, your payment reference is: ' + answer.ORDER_ID
              } else {
                this.false = true
                this.paymentResult =  'Payment Failed. Reason: ' + answer.MESSAGE
              }
            },
            response.details,
            { onResize: (data) => {this.height = Number(data.height.replace('px','')) + 10}});
          })
      }
		},
		getReceipt() {
      let self = this
      if(this.unpaid.length > 0 && Object.keys(this.hppResponse).length > 0) {
        this.$store.dispatch('onlinePaymentStore/getReceipt',
        {
          documents: this.unpaid,
          hppResponse: this.hppResponse
        }).then(response => {
          self.$parent.searchDocuments()
        })
      } else {
        this.false = true
        this.paymentResult = 'An unexpected error has occured. Please contact an administrator with payment reference ' + this.hppResponse.ORDER_ID
      }
		},
		submitted() {
			this.showButton = false
			this.timedOut = false
			this.timeout = setTimeout((e) => {
				this.timedOut = true
      },120000)
      //this.closeModal()
    },
    removeFromCart(docId) {
      this.showCheckoutButton()
      document.getElementById("targetIframe").style.display = "none"
      document.getElementById("targetIframe").src = ''
      let docs = this.$attrs.modal.docuData.docsChecked

      // check if the doc id really exists in the list, if yes remove it and get updated data
      let index = docs.indexOf(docId);
      if (index !== -1) docs.splice(index, 1)
      this.$attrs.modal.docuData.docsChecked = docs
      this.getCart()
    }
	}
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
.doc-list {
  width: 300px;
  height: 250px;
  overflow: auto;
}
.nav-link >>> .doc-button{
  border-radius: 0 !important;
}
.brand-color > th {
  background-color: #047bf8 !important;
  color: white !important;
}
</style>

<style>
@media (min-width: 992px)
{
  .modal-lg, .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px)
{
  .modal-xl {
    max-width: 1140px;
  }
}


</style>
